import React from "react"
import classNames from "classnames"
import "./assets/styles/style.scss"
import PropTypes from "prop-types"
import Block from "@bappweb/block"
import Element from "@bappweb/element"

const Currency = props => {
  const getThousands = value => {
    const val = isNaN(value) ? 0 : value * 1
    return val
      .toFixed(2)
      .split(".")[0]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

  const getPrecision = value => {
    const val = isNaN(value) ? 0 : value * 1
    return val.toFixed(2).split(".")[1]
  }

  return (
    <Block
      id={props.id}
      className={classNames(
        "bapp-currency",
        props.className,
        props.size ? `bapp-currency-${props.size}` : ""
      )}
    >
      {getThousands(props.value)}
      {","}
      <Element type="sub">{getPrecision(props.value)}</Element>
      <Element
        type="span"
        className={props.sizeCurrency ? `bapp-currency-text-${props.sizeCurrency}` : null}
      >
        {props.currency}
      </Element>
    </Block>
  )
}

Currency.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
  currency: PropTypes.oneOf(["TL", "USD", "EUR"]),
  size: PropTypes.oneOf(["xxs", "xs", "sm", "md", "lg", "xl"]),
  sizeCurrency: PropTypes.oneOf(["sm", "lg"]),
}

export default Currency
